export default __webpack_public_path__ + "static/media/fantasyscores.cea18bd1.jpg";